import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./notFoundMenu.module.css";

const NotFoundMenu = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <div className={styles.glowOne}></div>
      <div className={styles.glowTwo}></div>

      <div className={styles.card}>
        <div className={styles.code}>404</div>

        <h1 className={styles.title}>{t("page_not_found_title")}</h1>

        <p className={styles.description}>
          {t("page_not_found_description")}
        </p>

        <div className={styles.actions}>
          <button
            className={`${styles.button} ${styles.secondary}`}
            onClick={() => window.history.back()}
            type="button"
          >
            {t("go_back")}
          </button>

          <button
            className={`${styles.button} ${styles.primary}`}
            onClick={() => navigate("/menu/dashboard")}
            type="button"
          >
            {t("go_to_dashboard")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundMenu;